import axios from 'axios';

import type { Email } from '@apple/features/report/email/models/listing';
import { emailSchema } from '@apple/features/report/email/models/listing';

export async function getEmail(emailId: string): Promise<Email> {
	const data = (await axios.get<Email>(`/api/emails/${encodeURIComponent(emailId)}`)).data;
	return emailSchema.parse(data);
}
